// payment refund process


import React from "react";


// import { Box, Typography } from "@mui/material";

import { Box, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { StyledTableCell, StyledTableRow } from "Pages/AdminList/ProfessionalUserList";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Chip, keyframes, styled } from "@mui/material";
import ColorData from "Components/CstmTheme/ColorData";
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from "react-redux";
import { setAlertData, startLoading, stopLoading } from "../../Redux/Screen/Action";
import { StatusChip } from "Pages/OrderHistory/OrderHistory";
import PaymentApi from "Service/Payment.api";
import AdminApi from "Service/Admin.api";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
const pulse = keyframes`
0% { transform: scale(1); }
50% { transform: scale(1.05); }
100% { transform: scale(1); }
`;


interface PaymentHistoryInterface {
  pkPayment: number,
    amount: number,
    currency: string,
    paymentDate: string,
    paymentStatus: string,
    transactionId: string,
    paymentGateway: string,
    paymentType: number,
    caseTypeId: number,
    caseTypeName: string,
    orderTypeId: number,
    orderTypeName: string,
    caseId: number

createdDate: string

id : number
name: string
email: string
contactNumber: string
role: string
paymentId: string
refundReason: string
requestedByAdminUserId: string
status: string
userId: string
}

const PaymentProcess: React.FC = () => {
    const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [searchQuery, setSearchQuery] = useState("");
const [paymentHistory, setPaymentHistory] = useState<PaymentHistoryInterface[]>([]);
const [filteredHistory, setFilteredHistory] = useState<PaymentHistoryInterface[]>([]);

const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
const [paymentToRefund, setPaymentToRefund] = useState<PaymentHistoryInterface | null>(null);
const [userRole, setUserRole] = useState<string | null>(null); 
  const dispatch = useDispatch();
  useEffect(() => {
    fetchPaymentHistory();
  }, [])

  useEffect(() => {
    const normalizedQuery = searchQuery.toString().toLowerCase().trim();

    if (normalizedQuery === "") {
      setFilteredHistory(paymentHistory);
      return;
    }

    const filtered = paymentHistory?.filter((payment: any) => {
      const pkPayment = payment.pkPayment?.toString().toLowerCase() ?? "";
      const caseType = payment.caseTypeName?.toLowerCase() ?? "";
      const orderType = payment.orderTypeName?.toLowerCase() ?? "";
      const amount = payment.amount?.toString() ?? "";
      const transId = payment.transactionId?.toLowerCase() ?? "";
      const caseId = payment.caseId?.toString() ?? "";
      const status = payment.status?.toLowerCase() ?? "";
      const paymentId = payment.paymentId?.toString() ?? "";

      return (
        pkPayment.includes(normalizedQuery) ||
        caseType.includes(normalizedQuery) ||
        orderType.includes(normalizedQuery) ||
        amount.includes(normalizedQuery) ||
        transId.includes(normalizedQuery) ||
        caseId.includes(normalizedQuery) ||
        status.includes(normalizedQuery) ||
        paymentId.includes(normalizedQuery)
      );
    });

    setFilteredHistory(filtered || []);
  }, [searchQuery, paymentHistory]);

  const fetchPaymentHistory = async () => {
    dispatch(startLoading(
      {
        loading: true,
        loadtext: "",
      }
    ))
    const persistedData = localStorage.getItem("persist:root");

    if (persistedData) {
      try {
          // Step 2: Parse root JSON
          const parsedRoot = JSON.parse(persistedData);
          
          // Step 3: Parse 'user' property which is itself a JSON string
          const userObj = JSON.parse(parsedRoot.user);

            const userId = userObj?.myInfo?.id;
            const userRole = userObj?.myInfo?.userType;
            setUserRole(userRole);
            console.log("userId", userId);
            console.log("userRole", userRole);

            if (!userId || !userRole) {
                console.error("User ID or Role not found in persisted state.");
                dispatch(stopLoading());
                return;
            }

            let response;

            if (userRole === "SUPERADMIN") {
                response = await AdminApi.getRefundRequest();
            }
            else if (userRole === "ADMIN") { 
                response = await PaymentApi.getAdminPaymentHistory();
            } else {
                response = await PaymentApi.getUserPaymentHistory();
            }
          console.log("response", response.data);
        dispatch(stopLoading());
        setPaymentHistory(response.data || []);
        setFilteredHistory(response.data || []);

      } catch (error) {
        console.error("Failed to parse persisted user data:", error);
      }
    }
  };

  const formatDate = (date: string) => dayjs(date).format("DD MMM YYYY, hh:mm A");

  // Update the existing handleRefund function
const handleRefund = (payment: PaymentHistoryInterface) => {
    console.log("handleRefund called with payment:", payment);
    setPaymentToRefund(payment);
    setIsRefundModalOpen(true);
};


const initiateRefundApi = async () => {
    if (!paymentToRefund) return;

    // 1. Start Loading
    dispatch(startLoading({ loading: true, loadtext: "Processing refund..." }));

    try {
        
//  "paymentId": 0,
//   "transactionId": "string",
//   "caseId": 0,
//   "amount": 0.01
        const refundPayload = {
            paymentId: paymentToRefund.paymentId.toString(),
            amount: paymentToRefund.amount,
            transactionId: paymentToRefund.transactionId,
            caseId: paymentToRefund.caseId,
        };
        console.log("refundPayload", refundPayload);

        const response = await PaymentApi.refundPayment(refundPayload);
        console.log("Refund response:", response); 
        dispatch(
            setAlertData({
                alertMessage: "Refund processed successfully for Payment ID: " + paymentToRefund.paymentId,
                alertVariant: "success",
                openAlert: true,
            })
        );
        
        fetchPaymentHistory(); 
        setIsRefundModalOpen(false); 
        setPaymentToRefund(null); 

    } catch (error) {
        console.error("Refund failed:", error);
        dispatch(
            setAlertData({
                alertMessage: "Refund failed. Please try again.",
                alertVariant: "error",
                openAlert: true,
            })
        );
    } finally {
        dispatch(stopLoading());
    }
};

  const renderTable = () => (
    <Paper
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
      }}
    >
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell>Payment ID</StyledTableCell>
              <StyledTableCell>Case ID</StyledTableCell>
              <StyledTableCell>Transaction ID</StyledTableCell>
              <StyledTableCell>Refund Reason</StyledTableCell>
              {/* <StyledTableCell>Order Type</StyledTableCell> */}
              <StyledTableCell>Amount</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell>Created At</StyledTableCell>
              {userRole === "SUPERADMIN" && <StyledTableCell>Action</StyledTableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredHistory?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ py: 8 }}>
                  <Typography variant="h6">No Payments found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              Array.isArray(filteredHistory) &&
              filteredHistory?.map((payment) => (
                <StyledTableRow key={payment.paymentId}>
                  <TableCell>{payment.paymentId}</TableCell>
                  <TableCell>{payment.caseId}</TableCell>
                  <TableCell>{payment.transactionId}</TableCell>
                  <TableCell>{payment.refundReason}</TableCell>
                  {/* <TableCell>{payment.caseTypeName}</TableCell> */}
                  {/* <TableCell>{payment.orderTypeName}</TableCell> */}
                  {/* <TableCell>{payment.caseTypeName}</TableCell> */}
                  <TableCell>{payment.amount}</TableCell>
                  <TableCell>
                    <StatusChip
                      label={payment.status}
                      status={payment.status}
                    />
                  </TableCell>
                  <TableCell>{formatDate(payment.createdDate)}</TableCell>
                  {/* 🎯 NEW: Refund Button for Admin */}
                  {userRole === "SUPERADMIN" && (
                    <Box mt={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => handleRefund(payment)}
                        disabled={(payment.status === "Completed")}>
                        {payment.status === "Completed" ? "Refunded" : "Refund"}
                      </Button>
                    </Box>
                  )}
                </StyledTableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );

  const renderCards = () => (
    <Box display="flex" flexDirection="column" gap={2}>
      {paymentHistory?.length === 0 ? (
        <Typography variant="body1" align="center">
          No Payments found
        </Typography>
      ) : (
        Array.isArray(paymentHistory) &&
        paymentHistory?.map((payment) => (
          <Card key={payment.pkPayment} variant="outlined" sx={{ borderRadius: 2 }}>
            <CardContent>
                <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                Payment ID: {payment.pkPayment}
              </Typography>
              <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                Case No: {payment.caseId}
              </Typography>
              <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                Transaction ID {payment.transactionId}
              </Typography>
              <Typography variant="body2">
                <strong>Case Type:</strong> {payment.caseTypeName}
              </Typography>
              <Typography variant="body2">
                <strong>Order Type:</strong> {payment.orderTypeName}
              </Typography>
              <Typography variant="body2">
                <strong>Amount:</strong> {payment.amount}
              </Typography>
              <TableCell>
                <StatusChip
                  label={payment.status}
                  status={payment.status}
                />
              </TableCell>
              <Typography variant="body2">
                <strong>Created:</strong> {formatDate(payment.paymentDate)}
              </Typography>
              {userRole === "SUPERADMIN" && (
                <Box mt={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => handleRefund(payment)}
                    disabled={(payment.status === "Completed")}>
                    {payment.status === "Completed" ? "Refunded" : "Refund"}
                  </Button>
                </Box>
              )}
            </CardContent>
          </Card>
        ))
      )}
    </Box>
  );

  return (
    <Box
      p={3}
      width="100%"

    >
       {/* 3. ADDED BACK BUTTON HERE */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Button 
          startIcon={<ArrowBackIcon />} 
          onClick={() => navigate(-1)}
          sx={{ fontWeight: 'bold' }}
        >
          Back
        </Button>
      </Box>
      <Typography variant="h5" fontWeight="bold" gutterBottom sx={{
        padding: 2,
        borderRadius: 2,
        backgroundColor: theme => ColorData.primary.main,
        color: theme => ColorData.text.secondary,
      }}>
        Process Payment Refunds
      </Typography>
      <TextField
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search payment history..."
        size="small"
        sx={{ width: { xs: '100%', sm: '300px', padding: 6 } }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    <Box 
      sx={{ 
        width: '100%',
        maxHeight: { xs: "65vh", md: "none" }, 
        overflowY: { xs: "auto", md: "visible" },
        pr: { xs: 1, md: 0 } 
      }}
    >
      {isMobile ? renderCards() : renderTable()}
    </Box>


        {/* 🎯 NEW: REFUND CONFIRMATION MODAL */}
        <Dialog
            open={isRefundModalOpen}
            onClose={() => setIsRefundModalOpen(false)}
        >
            <DialogTitle sx={{ color: theme.palette.error.main }}>
                Confirm Refund
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ color: "black" }}>
                    Are you sure you want to refund the payment
                    of <strong>{paymentToRefund?.currency} {paymentToRefund?.amount}</strong> (Case ID: {paymentToRefund?.pkPayment})?
                    This action cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => setIsRefundModalOpen(false)}
                    color="primary"
                    sx={{ textTransform: 'none' }}
                >
                    No, Cancel
                </Button>
                <Button
                    onClick={initiateRefundApi}
                    variant="contained"
                    color="primary"
                    autoFocus
                    sx={{ textTransform: 'none' }}
                >
                    Yes, Initiate Refund
                </Button>
            </DialogActions>
        </Dialog>
    </Box>
  );
};




export default PaymentProcess;
